const state = {
  cacheSystems: [],
};

const mutations = {
  GET_CACHE_SYSTEMS(state) {
    return state.cacheSystems;
  },

  SET_CACHE_SYSTEMS(state, items) {
    state.cacheSystems = items;
  },
};

const actions = {
  getCacheSystems({ commit }) {
    commit("GET_CACHE_SYSTEMS");
  },

  setCacheSystems({ commit }, exec) {
    commit("SET_CACHE_SYSTEMS", exec);
  },
};

const getters = {
  getCacheSystems: (state) => state.cacheSystems,
};

const module = {
  state,
  mutations,
  actions,
  getters,
};

export default module;
